import { Box, Button, Icon, IconButton, Typography } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FlatList from "flatlist-react/lib";
import { Close } from "@mui/icons-material";
import { useMemo } from "react";
import { handleUploadPdf } from "../../../../utils";
import DocumentSvgIcon from "../../../../assets/icons/document";

const PdfSection = ({ pdfs, onUpload, onRemove }) => {
  const AddComponentPdf = () => {
    return (
      <Button
        onClick={() => handleUploadPdf(onUpload)}
        className="flex flex-row gap-1 rounded-md justify-center items-center"
        sx={{
          border: "1px solid #E7EBF1",
          borderRadius: "8px",
          padding: "6px 12px",
          "&:hover": {
            backgroundColor: "transparent",
            border: "1px solid #E7EBF1",
          },
        }}
      >
        <Icon
          component={PictureAsPdfIcon}
          sx={{ fontSize: 20, color: "#687382" }}
        />
        <p className="text-[#687382] font-[10px]">Select PDF</p>
      </Button>
    );
  };

  const renderItem = (item, index) => {
    return (
      <Box key={index} sx={{ position: "relative", display: "inline-block" }}>
        <Button
          className="flex flex-row px-4 py-2 gap-2 border border-[#00684E] rounded-lg justify-center items-center mr-2 mb-4"
          sx={{
            border: "1px solid #00684E",
            borderRadius: "8px",
            padding: "6px 12px",
          }}
        >
          <DocumentSvgIcon />
          <Typography className="text-[#42424F] text-[12px] font-bold">
            {item?.name?.length > 10
              ? `${item?.name.substring(0, 20)}...`
              : item?.name}
          </Typography>
        </Button>
        <IconButton
          sx={{
            position: "absolute",
            top: -10,
            right: -2,
            background: "#F3F3F3",
            width: 18,
            height: 18,
            zIndex: 10,
          }}
          size="small"
          onClick={() => onRemove(index)}
        >
          <Close sx={{ fontSize: "12px" }} />
        </IconButton>
      </Box>
    );
  };

  const ListEmpty = () => {
    return (
      <div className="text-center text-[16px] font-['Poppins-Medium']"></div>
    );
  };

  const RENDER_PDF = useMemo(
    () => (
      <FlatList
        key={"REFERENCE-PDF-LIST"}
        list={[...pdfs]}
        renderItem={renderItem}
        renderWhenEmpty={ListEmpty}
      />
    ),
    [pdfs]
  );

  return (
    <Box>
      <Typography variant="h6">Attached PDF</Typography>
      <Box flexGrow={1} mt={2}>
        {RENDER_PDF}
      </Box>
      <div className="mt-1">
        <AddComponentPdf />
      </div>
    </Box>
  );
};
export default PdfSection;
